export function createDebouncer(delay: number) {
	let timeoutId: number | undefined

	return function debounce(callback: () => void) {
		clearTimeout(timeoutId)
		timeoutId = setTimeout(callback, delay)
	}
}
